export const isInArgumentFieldValid = (inArguments, fieldName) => {
  const name = inArguments.get(fieldName);
  if (name === undefined) return false;
  else if (name.length < 1) return false;
  return true;
};